// extracted by mini-css-extract-plugin
module.exports = {"manageCookiesButton":"gcIW9","backButton":"_31QZs","arrow":"_2THXn"};